import { BaseRouteService } from 'core/services';

class SplitOrderRouteService extends BaseRouteService {
	constructor() {
		super();
		this.base = 'split-order/';
	}

	splitOrderAsync(orderId, sourceOfChange) {
		return super.get(this.base + 'split/{id}/?sourceOfChange={sourceOfChange}', orderId, { sourceOfChange });
	}
}

export default SplitOrderRouteService;



// WEBPACK FOOTER //
// ./src/common/data/route-services/SplitOrderRouteService.js